import { buildModelManager } from "../builder.js";
const DefaultShopifyCompanyAddressSelection = {
  __typename: true,
  id: true,
  address1: true,
  address2: true,
  city: true,
  companyBillingLocationId: true,
  companyName: true,
  companyShippingLocationId: true,
  country: true,
  countryCode: true,
  createdAt: true,
  formattedAddress: true,
  formattedArea: true,
  phone: true,
  province: true,
  recipient: true,
  shopId: true,
  updatedAt: true,
  zipCode: true,
  zoneCode: true
};
const modelApiIdentifier = "shopifyCompanyAddress";
const pluralModelApiIdentifier = "shopifyCompanyAddresses";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCompanyAddressSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyCompanyAddress does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyCompanyAddressManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyCompanyAddressSelection,
  operations
);
export {
  DefaultShopifyCompanyAddressSelection,
  ShopifyCompanyAddressManager
};
//# sourceMappingURL=ShopifyCompanyAddress.js.map
